import React, { useState } from 'react';
import './EditableField.css'; // We'll create this CSS file next

const EditableField = ({ label, value, onSave, inputType = 'text', options = [] }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value || '');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(currentValue);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to save:", error);
      // The parent component will show a toast notification
    } finally {
      setIsSaving(false);
    }
  };

  const renderInput = () => {
    if (inputType === 'select') {
      return (
        <select value={currentValue} onChange={(e) => setCurrentValue(e.target.value)}>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      );
    }
    return (
      <input
        type={inputType}
        value={currentValue}
        onChange={(e) => setCurrentValue(e.target.value)}
        placeholder={`Enter ${label}`}
      />
    );
  };

  return (
    <div className="profile-row">
      <span className="profile-label">{label}:</span>
      {isEditing ? (
        <div className="edit-container">
          {renderInput()}
          <div className="edit-actions">
            <button className="btn-save" onClick={handleSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save'}
            </button>
            <button className="btn-cancel" onClick={() => setIsEditing(false)}>Cancel</button>
          </div>
        </div>
      ) : (
        <div className="display-container">
          <span className="profile-value">{value || 'Not set'}</span>
          <button className="btn-edit" onClick={() => setIsEditing(true)}>Edit</button>
        </div>
      )}
    </div>
  );
};

export default EditableField;